import AddServiceAttributeModal from './AddServiceAttributeModal';

export default AddServiceAttributeModal;
